<template>
    <div>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="monitorTaskLogData" :allowPaging="true" ref="grid" :allowExcelExport='true' >
          <e-columns>
            <!-- <e-column type="checkbox" width="50" textAlign="center"></e-column> -->
            <e-column field="code" :visible="false"></e-column>
            <e-column field="name" :headerText="$t('Monitor.record.product')" width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
</template>
<script>
import BasicLayout from '../../../layouts/BasicLayout';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'monitorSystemLog',
  components: {
    BasicLayout,
  },
  data() {
    return {
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-confirm', tooltipText: this.$t('Monitor.systemLog.startup'), click: this.startup },
        { prefixIcon: 'icon hero-icon hero-icon-disable', tooltipText: this.$t('Monitor.systemLog.shutdown'), click: this.shutdown },
      ],
      monitorTaskLogData: [],
      product: '',
      productList: [],
    };
  },
  mounted() {
    let That = this;
  },
  methods: {
    getproductList() {
      const url = '/lte/ems/sys/monitor/log/getProducts';
      const That = this;
      this.axios.get(url).then(response => {
        let productList = response.data.filter(item => !item.name.includes('ems_5gc') && !item.name.includes('ems_gnb') && !item.name.includes('ems_tr069'));
        That.monitorTaskLogData = productList;
      });
    },
    startup() {
      const record = this.getRecord();
      debugger
      if (record.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.selectOne')});
        return null;
      }
      if (record.length !== 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return null;
      }
      const url = '/lte/ems/sys/monitor/log/startShell?code=' + record[0].code;
      this.axios.get(url).then(response => {
        const result = response.data;
        if(result) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Monitor.systemLog.startupSuccess')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('Monitor.systemLog.startupFail')});
        }
      });
    },
    shutdown() {
      const record = this.getRecord();
      debugger
      if (record.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.selectOne')});
        return null;
      }
      if (record.length !== 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return null;
      }
      const url = '/lte/ems/sys/monitor/log/shutdownShell?code=' + record[0].code;
      this.axios.get(url).then(response => {
        const result = response.data;
        if(result) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Monitor.systemLog.shutdownSuccess')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('Monitor.systemLog.shutdownFail')});
        }
      });
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
